import update from 'immutability-helper/index';
import shortid from 'shortid';

import {
    DELETE_ITEM_IMAGE,
    FETCHED_POPUP_DATA,
    UPDATE_ITEM_TEXT,
    UPDATE_ITEM_IMAGE,
    UPDATE_ITEM_IMAGE_CROP,
    UPDATE_ITEM_IMAGE_CROP_RATIO,
    UPDATE_ITEM_IMAGE_CROP_THUMB,
    UPDATE_ITEM_IMAGE_META,
    UPDATE_SECTION_TITLE,
    UPDATE_SECTION_SETTING,
} from '../types/text_columns_multiple_media';

const INITIAL_STATE = {
    sectionSettings: [],
    data: {
        text_columns_multiple_media: [],
    },
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case DELETE_ITEM_IMAGE:
            return update(state, {
                data: {
                    text_columns_multiple_media: {
                        [action.payload.index]: {
                            image: {$merge: {deleted: true}},
                        },
                    },
                },
            });

        case FETCHED_POPUP_DATA:
            return update(state, {
                sectionId: {$set: action.payload.sectionId},
                pageId: {$set: action.payload.pageId},
                data: {$set: action.payload.sectionToEdit.data},
                sectionSettings: {
                    $set: action.payload.sectionToEdit.sectionSettings,
                },
            });

        case UPDATE_ITEM_TEXT:
            return update(state, {
                data: {
                    text_columns_multiple_media: {
                        [action.payload.index]: {
                            text: {
                                $set: action.payload.text,
                            },
                        },
                    },
                },
            });

        case UPDATE_ITEM_IMAGE:
            let image = action.payload.image;

            let imageObject = {
                id: shortid.generate(),
                url: image.preview,
                preview: image.preview,
                alt: '',
                title: '',
                description: '',
                link: '',
                filename: image.name,
                name: image.name,
                new: true,
                deleted: false,
                imageObject: image,
                croppedImage: null,
                croppedImageObject: null,
                croppedImageRatioId: null,
                croppedImageThumb: null,
                croppedImageThumbObject: null,
            };

            return update(state, {
                data: {
                    text_columns_multiple_media: {
                        [action.payload.index]: {
                            image: {
                                $set: imageObject,
                            },
                        },
                    },
                },
            });

        case UPDATE_ITEM_IMAGE_CROP:
            return update(state, {
                data: {
                    text_columns_multiple_media: {
                        [action.payload.index]: {
                            image: {
                                $merge: {
                                    croppedImage: action.payload.imageUrlBlob,
                                    croppedImageObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_ITEM_IMAGE_CROP_RATIO:
            return update(state, {
                data: {
                    text_columns_multiple_media: {
                        [action.payload.index]: {
                            image: {
                                $merge: {
                                    croppedImageRatioId:
                                        action.payload.cropRatioId,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_ITEM_IMAGE_CROP_THUMB:
            return update(state, {
                data: {
                    text_columns_multiple_media: {
                        [action.payload.index]: {
                            image: {
                                $merge: {
                                    croppedImage: action.payload.imageUrlBlob,
                                    croppedImageObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_ITEM_IMAGE_META:
            return update(state, {
                data: {
                    text_columns_multiple_media: {
                        [action.payload.index]: {
                            image: {
                                $merge: {
                                    alt: action.payload.imageMeta.alt,
                                    title: action.payload.imageMeta.title,
                                    description:
                                        action.payload.imageMeta.description,
                                    link: action.payload.imageMeta.link,
                                    filename: action.payload.imageMeta.name,
                                    name: action.payload.imageMeta.name,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_SECTION_TITLE:
            return update(state, {
                data: {
                    title: {$set: action.payload},
                },
            });

        case UPDATE_SECTION_SETTING:
            const toEditSettingPosition = state.sectionSettings.findIndex(
                (item) => item.id === action.payload.forSetting.id
            );

            if (toEditSettingPosition < 0) {
                return update(state, {
                    sectionSettings: {
                        $push: [
                            {
                                id: action.payload.forSetting.id,
                                name: action.payload.forSetting.name,
                                machine_name:
                                    action.payload.forSetting.machine_name,
                                options: action.payload.selectedOptions,
                            },
                        ],
                    },
                });
            } else {
                return update(state, {
                    sectionSettings: {
                        [toEditSettingPosition]: {
                            options: {$set: action.payload.selectedOptions},
                        },
                    },
                });
            }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/builder/sections/reducers/text_columns_multiple_media.js